import { Box, Text } from '@opendoor/bricks-next';
import { CtaInput } from '@opendoor/bricks/complex';
import { Card, Flex, InputProps } from '@opendoor/bricks/core';

import ValuePropsSection from './ValuePropsSection';

interface IProps {
  headerText: string;
  inputType: 'email';
  loading?: boolean;
  placeholder: string;
  emailValue: string | undefined;
  isEmailInvalid: boolean | undefined;
  onEmailChange: InputProps['onChange'];
  onSubmit: (event: React.FormEvent<HTMLElement>) => Promise<void>;
}

const Hero = (props: IProps) => (
  <Card
    className="hero-container"
    mt={11}
    mx={4}
    pt={11}
    backgroundColor="brand50"
    backgroundSize="cover"
    borderRadius={['none', null, 'semiRounded']}
    height={[null, null, null, '600px']}
  >
    <Flex
      flexDirection="column"
      alignItems="start"
      width="100%"
      padding={['0% 5% 0%', null, null, '0']}
    >
      <Flex
        flexDirection="column"
        alignItems="start"
        margin={['0 auto 45%', '0 auto 25%', '0 auto 25%', '0 auto 25%']}
        px={[3, 0]}
        maxWidth="929px"
      >
        <Text
          //Mark Title as h1 for SEO
          tag="h1"
          typography="$headerSmall"
          mb="$7x"
          color="$contentInversePrimary"
          textAlign="left"
          $largerThanSM={{
            maxWidth: '50%',
          }}
          ml={0}
        >
          {props.headerText}
        </Text>
        <Box width="100%" height="$32x" marginTop="$2x">
          <CtaInput
            designStyle="roundedSquare"
            placeholderText={props.placeholder}
            inputType={props.inputType}
            onChange={props.onEmailChange}
            value={props.emailValue}
            unboundedWidth={true}
            onSubmit={props.onSubmit}
            paddingLevel="light"
            ctaProps={{
              /** TODO @partnerships Semantic buttons without onClick methods are a11y violations. See https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1943339236/Accessibility+best+practices+for+frontend+development#Adding-onClick-handlers-to-non-interactive-elements-such-as-%3Cdiv-/%3E-or-%3CBox-/%3E-not-started */
              onClick: () => {},
              actionText: 'Get started',
              'aria-label': '',
              loading: props.loading,
            }}
          />
          {props.isEmailInvalid && (
            <Text
              tag="p"
              backgroundColor="$backgroundStateInactiveAccentError"
              typography="$labelSmall"
              pl="$4x"
              py="$4x"
              color="$contentInversePrimary"
              textAlign="left"
              borderRadius="$4x"
              mt={3}
            >
              Please use an email address associated with your builder to continue.
            </Text>
          )}
        </Box>

        <ValuePropsSection
          valueProps={[
            {
              header: 'Streamline your process',
              description:
                'Create a custom profile to track and manage every touch point of your customer’s journey.',
            },
            {
              header: 'Help your client get started',
              description:
                'Help your client get started. Use the Home Eligibility Checker to confirm your client’s home is eligible.',
            },
            {
              header: 'Sell more homes, faster',
              description:
                'Get your clients a competitive estimated offer within minutes — all with a few simple clicks.',
            },
            {
              header: 'Access dedicated support',
              description:
                'Access your own partner manager, training, insights, and more to help you sell more homes.',
            },
          ]}
        />
      </Flex>
    </Flex>
  </Card>
);

export default Hero;
